var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSetCourse = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  focusable: "false",
  viewBox: "0 0 64 64"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 10.27,
  y: 45.41,
  width: 14.99,
  height: 2.32,
  transform: "translate(-27.73 26.2) rotate(-45)"
}), /*#__PURE__*/React.createElement("rect", {
  x: 19.53,
  y: 46.99,
  width: 10.61,
  height: 2.32,
  transform: "translate(-26.77 31.67) rotate(-45)"
}), /*#__PURE__*/React.createElement("rect", {
  x: 11.04,
  y: 38.49,
  width: 10.61,
  height: 2.32,
  transform: "translate(-23.25 23.17) rotate(-45)"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m50.86,11.28l-30.86,16.99,5.07,5.07-.77,2.65,4.04,4.04,2.65-.77,5.07,5.07,16.99-30.86-2.19-2.19Zm-18.1,26.11l-5.82-5.82,10.04-5.3,1.08,1.08-5.3,10.04Z"
})));
export default SvgSetCourse;